var _rect, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeAimMin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "url(#paint0_linear_1655_104868)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8981 18.572C32.8981 17.9256 33.4221 17.4016 34.0685 17.4016L39.4059 17.4016C40.0523 17.4016 40.5763 17.9256 40.5763 18.572C40.5763 19.2184 40.0523 19.7425 39.4059 19.7425H34.0685C33.4221 19.7425 32.8981 19.2184 32.8981 18.572Z",
    fill: "#1D1B18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1982 28.0001C15.1982 20.9299 20.9298 15.1984 28 15.1984C29.7683 15.1984 31.4529 15.5569 32.985 16.2052C32.0008 16.5412 31.293 17.474 31.293 18.572C31.293 19.9528 32.4124 21.0723 33.7933 21.0723L38.7671 21.0723C40.0546 23.0692 40.8018 25.4474 40.8018 28.0001C40.8018 35.0704 35.0702 40.8019 28 40.8019C20.9298 40.8019 15.1982 35.0704 15.1982 28.0001ZM28.1172 21.0149C28.4694 21.0149 28.8216 21.3671 28.8216 21.7193V22.5411H30.9348C31.287 22.5411 31.6392 22.8933 31.6392 23.2455V23.4803C31.6392 23.8325 31.287 24.1847 30.9348 24.1847H26.3562C26.004 24.1847 25.6518 24.4195 25.417 24.6543C25.0648 25.0065 24.9474 25.3587 24.9474 25.7109C24.9474 26.0631 25.1822 26.4153 25.417 26.6501C25.6518 26.8849 26.004 27.1197 26.3562 27.1197H29.526C30.3478 27.1197 31.1696 27.3545 31.7566 28.0589C32.3436 28.5285 32.6958 29.3503 32.6958 30.1721C32.6958 30.9939 32.461 31.6983 31.9914 32.2853C31.5218 32.8723 30.7 33.2245 29.8782 33.2245H29.0564V34.2811C29.0564 34.6333 28.7042 34.9855 28.352 34.9855H27.9998C27.6476 34.9855 27.2954 34.6333 27.2954 34.2811V33.2245H24.7126C24.3604 33.2245 24.0082 32.8723 24.0082 32.5201V32.1679C24.0082 31.8157 24.243 31.5809 24.5952 31.5809H29.526C29.9956 31.5809 30.3478 31.4635 30.5826 31.3461C30.9348 30.9939 31.0522 30.6417 31.0522 30.2895C31.0522 29.8199 30.8174 29.4677 30.5826 29.2329C30.2304 28.8807 29.8782 28.7633 29.526 28.7633H26.3562C25.6518 28.7633 24.83 28.4111 24.243 27.8241C23.656 27.3545 23.3038 26.5327 23.3038 25.7109C23.3038 24.8891 23.656 24.0673 24.243 23.5977C24.7126 23.0107 25.5344 22.6585 26.3562 22.6585H27.178V21.7193C27.178 21.3671 27.4128 21.0149 27.765 21.0149H28.1172Z",
    fill: "#1D1B18"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1655_104868",
    x1: 0,
    y1: 28.002,
    x2: 56,
    y2: 28.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB6E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B47B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CDA243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121891,
    stopColor: "#E2C15B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171403,
    stopColor: "#F0D76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232867,
    stopColor: "#F9E477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306282,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39399,
    stopColor: "#F9E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504894,
    stopColor: "#EFD665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635883,
    stopColor: "#E0C04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E8C853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808788,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EED465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#DDBB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C59826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA8916"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeAimMin);
export default __webpack_public_path__ + "static/media/Home_Aim_Min.13f9302c562770c5dc92de3bdd1fbb19.svg";
export { ForwardRef as ReactComponent };